import { create } from 'zustand';
import type { AvatarConfig, PlayerState } from '@etown/shared';

/** Roster-Eintrag — bewusst OHNE Position: die laeuft 15x/s nur durchs Spiel. */
export interface RosterEntry {
  id: string;
  userId: string;
  displayName: string;
  avatarColor: number;
  avatar: AvatarConfig | null;
  ringRequired: boolean;
}

interface PlayersState {
  selfId: string | null;
  roster: RosterEntry[];
  setSelf: (id: string) => void;
  setRoster: (players: PlayerState[]) => void;
  addPlayer: (player: PlayerState) => void;
  removePlayer: (id: string) => void;
  updateAvatar: (id: string, avatar: AvatarConfig) => void;
  setRingRequired: (id: string, ringRequired: boolean) => void;
  reset: () => void;
}

function toEntry(p: PlayerState): RosterEntry {
  return {
    id: p.id,
    userId: p.userId,
    displayName: p.displayName,
    avatarColor: p.avatarColor,
    avatar: p.avatar,
    ringRequired: p.ringRequired,
  };
}

/** Anwesenheitsliste fuer die React-UI (Sidebar, Namen). */
export const usePlayersStore = create<PlayersState>((set) => ({
  selfId: null,
  roster: [],
  setSelf: (id) => set({ selfId: id }),
  setRoster: (players) => set({ roster: players.map(toEntry) }),
  addPlayer: (player) =>
    set((state) => ({
      roster: state.roster.some((e) => e.id === player.id) ? state.roster : [...state.roster, toEntry(player)],
    })),
  removePlayer: (id) => set((state) => ({ roster: state.roster.filter((e) => e.id !== id) })),
  updateAvatar: (id, avatar) =>
    set((state) => ({ roster: state.roster.map((e) => (e.id === id ? { ...e, avatar } : e)) })),
  setRingRequired: (id, ringRequired) =>
    set((state) => ({ roster: state.roster.map((e) => (e.id === id ? { ...e, ringRequired } : e)) })),
  reset: () => set({ selfId: null, roster: [] }),
}));
